import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import SublayoutComponent from './js/sublayout.component';

ComponentsFactory.getInstance().define('sublayout', SublayoutComponent);
